import { render, staticRenderFns } from "./NotificationForm.vue?vue&type=template&id=7ecd2125"
import script from "./NotificationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports